// extracted by mini-css-extract-plugin
export default {"root":"PreferencesButton-root_UtG3R","icon":"PreferencesButton-icon_XwS4W"};